import {EnsAlertType} from "../../store/features/ens/types";

export const ENS_ALERT_REFRESH_INTERVAL_MS = 15000;

export const formatDateTime = (iso: string | null | undefined): string => {
    if (!iso) return '—';
    try {
        return new Date(iso).toLocaleString();
    } catch {
        return iso;
    }
};

export const TYPE_DOT_COLOR: Record<EnsAlertType, string> = {
    FRAUD: 'bg-[#f59e0b]',
    TASK: 'bg-[#22c55e]',
    POLICY: 'bg-[#3b82f6]',
    CUSTOM: 'bg-[#7c3aed]',
};

export const TYPE_LABEL: Record<EnsAlertType, string> = {
    FRAUD: 'Fraud',
    TASK: 'Task',
    POLICY: 'Policy',
    CUSTOM: 'Custom',
};
